<template>
  <div>
    <div v-if="subView === 'Default'">
      <div class="flex-1 relative pb-8 z-0">
        <div class="bg-white shadow">
          <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
            <div class="pt-6 pb-6 md:flex md:items-center justify-between lg:border-t lg:border-cool-gray-200">
              <div class="text-3xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
                <div v-if="selectedClub !== undefined">
                  {{ selectedClub.name }}
                </div>
              </div>

              <PrimaryButton
                text="New club"
                icon="fal fa-plus"
                @click="subView = 'NewClub'"
              />
            </div>

            <div
              v-if="selectedClub !== undefined"
              class="pb-4"
            >
              <Tabs
                :tabs="tabs"
                :selected-tab="selectedTab"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="pt-6 px-8 max-w-7xl ml-auto mr-auto" />
    </div>

    <div v-if="subView === 'NewClub'">
      <Form
        title="New club"
        secondary-action="Back"
        primary-action="Submit new club"
        primary-action-icon="fal fa-plus"
        :modal="false"
        :forms="newClubForm"
        @secondaryClick="secondaryClick"
        @success="newClubSuccess"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Form from '@/app/shared/components/form/form.vue';
import Tabs from '@/app/shared/components/navigation/tabs/tabs.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import {
  ServiceFormModel, PrefilledField,
} from '@/app/shared/components/form/classes';


export default {
  name: 'Club',

  components: {
    Tabs,
    PrimaryButton,
    Form,
  },

  data() {
    return {
      tabs: [
        { primaryText: 'Summary' },
        { primaryText: 'Users' },
        { primaryText: 'Settings' },
      ],
      selectedTab: 'Summary',

      subView: 'Default',

      newClubForm: [],
    };
  },

  computed: {
    ...mapState({
      availableClubs: state => state.club.availableClubs,
      selectedClub: state => state.club.selectedClub,
      tenantId: state => state.user.tenantId,
    }),
  },

  watch: {
    subView(newValue) {
      if (newValue === 'NewClub') {
        // Reinitialize forms when switching to NewClub view to ensure fresh values
        this.initForms();
      }
    },
  },

  mounted() {
    this.initForms();

    const url_string = window.location.href;
    const url = new URL(url_string);
    const value = url.searchParams.get('NewClub');

    if (value) {
      this.subView = 'NewClub';
    }
  },

  methods: {
    async newClubSuccess() {
      this.subView = 'Default';
      const clubs = this.availableClubs;
      await this.$store.dispatch('getAvailableClubs').then(() => {
        this.$store.dispatch('setSelectedClub', this.availableClubs[0]);
      });
    },

    initForms() {
      // Access store directly to ensure we get current values
      const tenantId = this.$store.state.user.tenantId;
      
      console.log('[Club] Initializing forms with values:', {
        tenantId,
      });

      this.newClubForm = [
        new ServiceFormModel(
          0,
          0,
          'Club Details',
          'We need to know a few things about your club.',
          'Clubs',
          'Create',
          [],
          [
            new PrefilledField('tenantId', tenantId),
            new PrefilledField('contactDetailsId', null),
          ],
        ),
      ];
    },

    secondaryClick() {
      this.subView = 'Default';
    },
  },

};
</script>
